import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  otherWorkThingsData: [],
  otherWorkThingsLoader: true,
  otherWorkThingsError: "",
};

const getEndpoint = (roomName) => {
   const loc = localStorage.getItem('userLocation');
   const prefix = loc === 'kkt' ? 'kkt' : '';
  // const prefix = localStorage.getItem('userLocation');
  const db = localStorage.getItem('projectDatabase') || '(default)'; // fallback for safety
  // return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}`;
  return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}/${db}`;
};

export const fetchOtherWorksList = createAsyncThunk(
  'fetchotherworkThings',
  async ({ } = {}, { rejectWithValue }) => {
    try {
      const url = getEndpoint('OtherWorks');
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch other works data');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const otherWorkReducer = createSlice({
  name: 'OtherWorkThings',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchOtherWorksList.fulfilled]: (state, action) => {
      state.otherWorkThingsData = action.payload;
      state.otherWorkThingsLoader = false;
      state.otherWorkThingsError = "";
    },
    [fetchOtherWorksList.pending]: (state) => {
      state.otherWorkThingsLoader = true;
      state.otherWorkThingsError = "";
    },
    [fetchOtherWorksList.rejected]: (state, action) => {
      state.otherWorkThingsLoader = false;
      state.otherWorkThingsError = action.payload ?? "Close the tab and start with new tab";
    },
  },
});

export default otherWorkReducer.reducer;